import styles from '@components/shared/images/atoms/Image/Image.module.scss';
import React, { CSSProperties, forwardRef, RefAttributes } from 'react';

interface IPlaceholderImageProps extends RefAttributes<any> {
  alt?: string;
  className?: string;
  style?: CSSProperties;
}

const PlaceholderImage = forwardRef(({
  alt, className, style,
}: IPlaceholderImageProps, ref) => {
  return (
    <img
      ref={ref as any}
      alt={alt || ''}
      className={`${className || ''} ${styles['a-image-placeholder']}`}
      style={style}
    />
  );
});
export default PlaceholderImage;
